export default __webpack_public_path__ + "static/media/9711 - Memo Mx.3341741b.jpeg";